<template>
    <div>
        <div class="pb-10 mb-12 border-b border-gray-200">
            <h2 class="pb-1 text-2xl font-bold text-left text-black no-underline normal-case non-italic">Review Subscription</h2>
            <p class="text-lg font-normal text-left no-underline normal-case non-italic">Please review the information below to ensure the details are correct before confirming your investment.</p>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-12 gap-y-8">
            <div class="col-span-1">
                <h4 class="block text-base font-medium text-gray-500">Account Name</h4>
                <div class="py-1 mt-1 text-lg border-b border-gray-200">{{ reviewData.accountName }}</div>
            </div>

            <div class="col-span-1">
                <h4 class="block text-base font-medium text-gray-500">Offering Name</h4>
                <div class="py-1 mt-1 text-lg border-b border-gray-200">Alt Investment Co.</div>
            </div>

            <div class="col-span-1">
                <h4 class="block text-base font-medium text-gray-500">Email Address</h4>
                <div class="py-1 mt-1 text-lg border-b border-gray-200">hello@altinvestment.com</div>
            </div>

            <div class="col-span-1">
                <h4 class="block text-base font-medium text-gray-500">Total Amount</h4>
                <div class="py-1 mt-1 text-lg border-b border-gray-200" v-currency="{prefix: '$'}">{{ reviewData.totalAmount }}</div>
            </div>

            <div class="col-span-1">
                <h4 class="block text-base font-medium text-gray-500">Phone Number</h4>
                <div class="py-1 mt-1 text-lg border-b border-gray-200">{{ reviewData.phoneNumber }}</div>
            </div>

            <div class="col-span-1">
                <h4 class="block text-base font-medium text-gray-500">Address</h4>
                <div class="py-1 mt-1 text-lg border-b border-gray-200">{{ reviewData.address }}</div>
            </div>
        </div>

        <div class="flex justify-between mt-20">
            <div>
                <app-button @click="handleBack" :disable="isBusy" class="!border-gray-200 !bg-white !text-gray-400">Back</app-button>
            </div>

            <div class="inline-flex items-center space-x-3">
                <div class="text-right">
                    <app-button @click="handleNext" :busy="isBusy">Finish</app-button>
                    <!-- <app-button v-else @click="handleDocusign" :busy="isBusy">Send for Signature</app-button>
                    <p v-if="isDocusign" class="pt-5 text-xs text-right text-gray-500" style="max-width: 365px;">Click the button above to launch documents for e-signature. This may take a few moments. Please do not close your browser</p> -->
                </div>
            </div>
        </div>
    </div>

    <teleport to="body">
        <div v-show="isBusy" class="fixed inset-0 overflow-y-auto z-[99999]">
            <div class="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
                <div class="fixed inset-0 z-10 bg-gray-800 bg-opacity-25 backdrop-filter backdrop-blur-sm"></div><!-- overlay -->

                <span class="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span><!-- center trick -->

                <div class="relative z-20 inline-block overflow-hidden align-bottom bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                    <div class="text-center bg-white bg-left-top bg-no-repeat bg-cover p-14" :style="'background-image: url(' + asset('img/panel-bg.png') + ')'">
                        <h3 class="mb-8 text-2xl font-bold text-black">This may take a few moments. <br/>Please do not close your browser</h3>
                        <div class="mx-auto w-28 h-28">
                            <img :src="asset('img/spinner.gif')" alt="spinner" class="w-full h-auto">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </teleport>

    <teleport to="body">
        <div v-show="!isBusy && showDocusign" class="fixed inset-0 overflow-y-auto z-[99999]">
            <div class="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
                <div class="fixed inset-0 z-10 bg-gray-800 bg-opacity-25 backdrop-filter backdrop-blur-sm"></div><!-- overlay -->

                <span class="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span><!-- center trick -->

                <div class="relative inline-block align-bottom bg-white rounded-lg overflow-hidden shadow-xl z-20 sm:my-8 sm:align-middle sm:max-w-[98%] sm:w-full">
                    <div class="p-3">
                        <iframe :src="docusignEmbedURL" style="width: 100%; height: 100%; min-height: 1020px;" frameborder="0"></iframe>
                    </div>
                </div>
            </div>
        </div>
    </teleport>

    <teleport to="body">
        <div v-show="askSpouseDocusign" class="fixed inset-0 overflow-y-auto" style="z-index: 999999;">
            <div class="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
                <div class="fixed inset-0 transition-all transform">
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                <div class="inline-block overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                    <div class="px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4">
                        <div class="sm:flex sm:items-center">
                            <div class="flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto bg-blue-100 rounded-full sm:mx-0 sm:h-10 sm:w-10">
                                <svg class="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                            </div>
                            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                <h3 class="text-lg font-medium leading-6 text-gray-900" id="modal-title">
                                    Is your spouse available to sign right now?
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div class="px-4 py-3 bg-gray-50 sm:px-6 sm:flex sm:flex-row-reverse">
                        <button @click="handleSpouseDocusign" type="button" class="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-black border border-transparent rounded-md shadow-sm bg-teal focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal sm:ml-3 sm:w-auto sm:text-sm">
                            Yes
                        </button>
                        <button @click="askSpouseDocusign = false; isDocusign = false" type="button" class="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
                            No
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </teleport>
</template>

<script>
import AppButton from '@Components/Button'
import AppModal from '@Components/Modal'
import { useStore } from 'vuex'
import { computed, onMounted, onUnmounted, ref } from 'vue'

export default {
    components: {
        AppButton,
        AppModal
    },
    props: ['series'],
    emits: ['prev', 'next', 'process', 'complete', 'goto'],
    setup(props, { emit }){
        const store = useStore()

        const onboardingData = computed(() => {
            return {
                investingType: store.state.profileForm.investingType,
                subInvestingType: store.state.profileForm.subInvestingType,
                primaryData: store.state.profileForm.primary,
                secondaryData: store.state.profileForm.secondary,
                entityData: store.state.profileForm.entity,
                iraData: store.state.profileForm.ira,
                suitabilityData: store.state.suitabilityForm,
                investData: store.state.investForm,
            }
        })

        const reviewData = computed(() => {
            const investingType    = onboardingData.value.investingType
            const firstName        = _.get(onboardingData.value.primaryData, 'firstName', '')
            const lastName         = _.get(onboardingData.value.primaryData, 'lastName', '')
            const partnerFirstName = _.get(onboardingData.value.secondaryData, 'firstName', '')
            const partnerLastName  = _.get(onboardingData.value.secondaryData, 'lastName', '')
            const entityName       = _.get(onboardingData.value.entityData, 'entityName', '')
            const phoneNumber      = _.get(onboardingData.value.primaryData, 'mobilePhone', _.get(onboardingData.value.primaryData, 'phone', ''))
            const emailAddress     = _.get(onboardingData.value.primaryData, 'email', '')
            const address          = _.get(onboardingData.value.primaryData, 'address1', '')
            const fullName         = firstName + ' ' + lastName

            return {
                accountName: (investingType == 'entity') ? entityName : (investingType == 'joint' ? `${firstName} ${lastName} & ${partnerFirstName} ${partnerLastName}` : fullName),
                offeringName: 'Mammoth Technology, LLC',
                emailAddress: emailAddress,
                phoneNumber: phoneNumber,
                address: address,
                totalAmount: _.get(onboardingData.value.investData, 'amount', ''),
                fullName: fullName,
            }
        })

        const isBusy = ref(false)

        const isDone = ref(false)

        const isCompleting = ref(false)

        const isDocusign = ref((onboardingData.value.investingType == 'entity' && onboardingData.value.entityData.moreSignatures == 'Yes') ? false : true)

        const showDocusign = ref(false)

        const docusignEmbedURL = ref('')

        const docusignEnvelopeID = ref('')

        const askSpouseDocusign = ref(false)

        const isSpouseDocusignDone = ref(false)

        onMounted(() => {
            window.addEventListener('message', handleDocusignResponse);
        })

        onUnmounted(() => {
            window.removeEventListener('message', handleDocusignResponse);
        })

        function sayError(){
            alert('Opps! something went wrong. Please contact support team.')

            isBusy.value = false
        }

        function handleDocusignResponse(response){
            const responseData = response.data || response.message

            switch(responseData){
                case 'docusign_signing_complete':
                    showDocusign.value = false
                    isBusy.value = true

                    console.log(onboardingData.value.investingType)
                    console.log(isSpouseDocusignDone.value)

                    setTimeout(() => {
                        isBusy.value = false

                        if (onboardingData.value.investingType == 'joint' && !isSpouseDocusignDone.value) {
                            askSpouseDocusign.value = true
                        } else {
                            isDocusign.value = false
                        }
                    }, 1500)
                    break;
                case 'docusign_cancel':
                case 'docusign_decline':
                    showDocusign.value = false
                    isDocusign.value = false
                    isBusy.value = false
                    break;
            }
        }

        async function handleDocusign(){
            isBusy.value = true

            docusignEmbedURL.value = ''
            docusignEnvelopeID.value = ''

            let params = {
                _query: {
                    series: props.series
                }
            }

            let apiEndpoint = route('api.docusign.individual', params),
                hasError = false

            switch(onboardingData.value.investingType){
                case 'joint':
                    apiEndpoint = route('api.docusign.joint', params)
                    break;
                case 'entity':
                    apiEndpoint = route('api.docusign.entity', params)
                    break;
                case 'ira':
                    apiEndpoint = route('api.docusign.ira', params)
                    break;
            }

            // # GET ENVELOPE ID
            console.log('GETTING ENVELOPE ID..')
            await axios.post(apiEndpoint, onboardingData.value).then(response => {
                if (response.status == 200) {
                    docusignEnvelopeID.value = response.data
                } else {
                    hasError = true
                }
            }).catch(() => hasError = true)

            if (hasError) {
                sayError()
                return false
            }

            // # SAVE ENVELOPE ID
            console.log('SAVING ENVELOPE ID..')
            await axios.post(route('intake.validate.envelope'), {
                envelopeId: docusignEnvelopeID.value
            }).then(response => {
                if (response.status == 200) {
                    store.commit('UPDATE_FORM_ENVELOPE', docusignEnvelopeID.value);
                } else {
                    hasError = true
                }
            }).catch(() => hasError = true)

            if (hasError) {
                sayError()
                return false
            }

            // # GET EMBED VIEW
            console.log('GETTING EMBED VIEW..')
            await axios.post(route('api.docusign.view', {who: 'self', envelope_id: docusignEnvelopeID.value}), onboardingData.value).then(response => {
                if (response.status == 200) {
                    docusignEmbedURL.value = response.data
                } else {
                    hasError = true
                }
            }).catch(() => hasError = true)

            if (hasError) {
                sayError()
                return false
            }

            console.log('COMPLETE')
            isBusy.value = false
            showDocusign.value = true
        }

        async function handleSpouseDocusign(){
            askSpouseDocusign.value = false
            isBusy.value = true

            docusignEmbedURL.value = ''
            //docusignEnvelopeID.value = ''

            let hasError = false

            await axios.post(route('api.docusign.view', {who: 'spouse', envelope_id: docusignEnvelopeID.value}), onboardingData.value).then(response => {
                if (response.status == 200) {
                    docusignEmbedURL.value = response.data
                } else {
                    hasError = true
                }
            }).catch(() => hasError = true)

            if (hasError) {
                sayError()
                return false
            }

            isSpouseDocusignDone.value = true
            isBusy.value = false
            showDocusign.value = true
        }

        function handleNext(){
            emit('next', true)
        }

        function handleBack(){
            emit('back', true)
        }

        return {
            reviewData,
            onboardingData,
            isBusy,
            isDone,
            isCompleting,
            isDocusign,
            showDocusign,
            docusignEmbedURL,
            askSpouseDocusign,
            handleNext,
            handleBack,
            handleDocusign,
            handleSpouseDocusign,
        }
    }
}
</script>
